package com.exura.pages.planCreator.components.seriesViews.inputs

import androidx.compose.runtime.*
import com.exura.ui.*
import com.exura.ui.modifiers.ShadeBorder
import com.exura.ui.modifiers.insetHoverableItemStyle
import com.varabyte.kobweb.compose.css.CSSLengthNumericValue
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.toAttrs
import org.jetbrains.compose.web.attributes.InputType
import org.jetbrains.compose.web.attributes.readOnly
import org.jetbrains.compose.web.attributes.min
import org.jetbrains.compose.web.attributes.max
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.Input

@Composable
fun PlanCreatorIntegerInput(
    value: Int,
    onValueChange: (Int) -> Unit,
    mode: PlanCreatorInputMode,
    placeholder: String = "",
    modifier: Modifier = Modifier,
    textStyle: String = TextStyles.normal16,
    textHeight: CSSLengthNumericValue = 16.px,
    minValue: Int = 0,
    maxValue: Int = Int.MAX_VALUE,
    shadeColor: ExuraRgba? = null,
) {
    val inputHeight = textHeight + 4.px + 2 * 4.px
    var isSelected by remember { mutableStateOf(false) }
    var isFocused by remember { mutableStateOf(false) }
    var inputText by remember(value) { mutableStateOf(value.toString()) }

    val isInteractive = mode == PlanCreatorInputMode.EDIT
    val showPlaceholder = inputText.isEmpty() && !isFocused

    val accentColor = shadeColor ?: ExuraColors.BLUE

        Box(
            modifier = Modifier
                .insetHoverableItemStyle(
                    isSelected = isSelected && isInteractive,
                    shadeColor = accentColor.copy(alpha = 0.1),
                    shadeSize = 16.px,
                    shadeBorders = listOf(ShadeBorder.TOP, ShadeBorder.LEFT),
                    hoverColor = if (isInteractive) accentColor.copy(alpha = 0.05) else ExuraColors.TRANSPARENT,
                    selectedColor = accentColor.copy(alpha = 0.05),
                    cursor = if (isInteractive) Cursor.Text else Cursor.Default,
                    onClick = if (isInteractive) {
                        { isSelected = true }
                    } else null,
                    isHoverable = isInteractive
                )
                .height(inputHeight)
                .borderRadius(4.px)
                .padding(8.px)
                .textAlign(TextAlign.Start)
                .width(100.px)
                .then(modifier),
            contentAlignment = Alignment.CenterStart
        ) {
            Input(
                type = InputType.Number,
                attrs = Modifier
                    .fillMaxWidth()
                    .backgroundColor(Colors.Transparent)
                    .border(width = Dimens.spacingNone)
                    .outline(
                        width = Dimens.spacingNone,
                        style = LineStyle.None,
                        color = Colors.Transparent
                    )
                    .padding(leftRight = 12.px, topBottom = 8.px)
                    .classNames(textStyle)
                    .color(if (showPlaceholder) ExuraColors.ARSENIC2 else ExuraColors.ARSENIC)
                    .transition(
                        Transition.of(
                            property = "all",
                            duration = 0.2.s,
                            timingFunction = AnimationTimingFunction.EaseInOut
                        )
                    )
                    .textAlign(TextAlign.Start)
                    .toAttrs {
                        value(if (showPlaceholder) placeholder else inputText)
                        min(minValue.toString())
                        max(maxValue.toString())
                        if (isInteractive) {
                            onInput { event ->
                                onValueChange(event.value?.toInt() ?: 0)
                            }
                            onFocus {
                                isFocused = true
                                isSelected = true
                            }
                            onBlur {
                                isFocused = false
                                isSelected = false
                            }
                        } else {
                            readOnly()
                        }
                    }
            )
        }


}
